import { render, staticRenderFns } from "./idCardEdit.vue?vue&type=template&id=3f0843b3&scoped=true&"
import script from "./idCardEdit.vue?vue&type=script&lang=js&"
export * from "./idCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./idCardEdit.vue?vue&type=style&index=0&id=3f0843b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0843b3",
  null
  
)

export default component.exports